import { ref, unref } from 'vue';
import RelatorioAPI from 'dashboard/api/relatorio';
import { useAlert } from 'dashboard/composables';
import { periodRange } from '../utils/reportFormatters';

// Exportação do relatório de analytics (CSV/PDF/Excel) com o mesmo recorte de
// período, operação, imóvel e origem aplicado na tela.
export function useReportExport({
  periodo,
  operacao,
  selectedPropertyId,
  analyticsSource,
  analyticsSourceParams,
}) {
  const exportingFormat = ref('');

  const exportarRelatorio = async (format = 'csv') => {
    const { inicio, fim } = periodRange(unref(periodo));
    const exportMethods = {
      csv: RelatorioAPI.exportCsv.bind(RelatorioAPI),
      pdf: RelatorioAPI.exportPdf.bind(RelatorioAPI),
      xlsx: RelatorioAPI.exportXlsx.bind(RelatorioAPI),
    };
    const method = exportMethods[format] || exportMethods.csv;
    const labels = {
      csv: 'CSV',
      pdf: 'PDF',
      xlsx: 'Excel',
    };

    exportingFormat.value = format;
    try {
      const response = await method({
        inicio,
        fim,
        operacao: unref(operacao) === 'aluguel' ? 'aluguel' : 'venda',
        imovel_id: unref(selectedPropertyId) || undefined,
        ...unref(analyticsSourceParams),
      });
      const url = URL.createObjectURL(new Blob([response.data]));
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = `analytics-${unref(periodo)}-${unref(analyticsSource)}.${format}`;
      anchor.click();
      URL.revokeObjectURL(url);
    } catch {
      useAlert(`Não foi possível exportar o ${labels[format]} de analytics.`);
    } finally {
      exportingFormat.value = '';
    }
  };

  return { exportingFormat, exportarRelatorio };
}
